var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"container"}},_vm._l((_vm.cards),function(card){return _c('div',{key:card.id,staticClass:"card"})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }